import React from "react";
import "./style.scss";

const Footer = () => {
  return (
    <div className="G-Container">
      <p className="footer">Copyright © 2020 Simple House | Design: TemplateMo</p>
    </div>
  );
};

export default Footer;
